// extracted by mini-css-extract-plugin
export default {"create-row":"MenuLabelsField_create-row__MNXH5"};